import type { DividerTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const dividerDark: DividerTheme = {
  name: 'Divider',
  common: commonDark,
  self
}

export default dividerDark
